function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import useIntlMemo from '@/hooks/useIntlMemo';
import { FormattedMessage, useIntl } from 'react-intl';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { UserLevels } from '@/types/server';
import { WebRoutes } from '@/utils/constants';
import useChannelStore from '@/stores/ChannelStore';
import { useNavigate, useParams } from 'react-router';
import { getDefaultCommand, updateDefaultCommand } from '@/actions/CommandActions';
import { Helmet } from 'react-helmet';
import useDefaultCommandStore from '@/stores/DefaultCommandStore';
import useBackButton from '@/hooks/useBackButton';
import BackButton from '../BackButton';
import useDebouncedCallbackOnChange from '@/hooks/useDebouncedCallbackOnChange';
import { Button, Title, NativeSelect, Text, TextInput, NumberInput } from '@mantine/core';
import styles from './CommandsDefaultCreate.module.scss';
var DEFAULT_VALUES = {
    name: '',
    userLevel: UserLevels.EVERYONE,
    message: '',
    coolDown: 5,
    alias: ''
};
var MIN_COOLDOWN = 1;
var MAX_COOLDOWN = 300;
function useDefaultCommandFormSchema() {
    return useIntlMemo(function(intl) {
        return Yup.object().shape({
            userLevel: Yup.string().required(intl.formatMessage({
                id: "J4OhND",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Userlevel is required"
                    }
                ]
            })),
            coolDown: Yup.number().required(intl.formatMessage({
                id: "JVJy/u",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cooldown is required"
                    }
                ]
            })).min(MIN_COOLDOWN, intl.formatMessage({
                id: "DmRtwY",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cooldown must be at least 1 second long"
                    }
                ]
            })).max(MAX_COOLDOWN, intl.formatMessage({
                id: "+rzoMT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cooldown must be at most 300 seconds long"
                    }
                ]
            }))
        });
    }, []);
}
export default function CommandsDefaultEdit() {
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var navigate = useNavigate();
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(null), 2), error = _React_useState[0], setError = _React_useState[1];
    var commandName = useParams().commandName;
    var back = useBackButton(WebRoutes.COMMANDS_DEFAULT).back;
    var cachedCommand = useDefaultCommandStore(function(state) {
        return channel != null && commandName != null ? state.getCommand(channel._id, commandName) : null;
    });
    var DefaultCommandFormSchema = useDefaultCommandFormSchema();
    var formik = useFormik({
        initialValues: cachedCommand !== null && cachedCommand !== void 0 ? cachedCommand : DEFAULT_VALUES,
        validationSchema: DefaultCommandFormSchema,
        validateOnChange: false,
        validateOnMount: true,
        onSubmit: function(values, param) {
            var setSubmitting = param.setSubmitting;
            if (channel == null || commandName == null) {
                return;
            }
            setSubmitting(true);
            updateDefaultCommand(channel._id, _object_spread({
                _name: commandName
            }, values)).then(function() {
                return back();
            }).catch(function(error) {
                if (_instanceof(error, Error)) {
                    setError(error.message);
                } else {
                    setError('An unknown error occurred.');
                }
                setSubmitting(false);
            });
        }
    });
    useDebouncedCallbackOnChange(formik, formik.validateForm);
    React.useEffect(function() {
        if (channel == null) {
            return;
        }
        if (commandName == null) {
            navigate(WebRoutes.COMMANDS_CUSTOM);
            return;
        }
        getDefaultCommand(channel._id, commandName).then(function(command) {
            return formik.resetForm({
                values: command
            });
        }).catch(function() {
            return navigate(WebRoutes.COMMANDS_CUSTOM);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        commandName,
        channel,
        navigate
    ]);
    var _formik_values_name, _channel_userLevels, _formik_values_coolDown;
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        containerProps: {
            maxWidth: 'container.md'
        },
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "vGHy7d",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Edit Default Command"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(BackButton, {
                fallbackParams: WebRoutes.COMMANDS_CUSTOM,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "TY8Ho1",
                    defaultMessage: "Commands"
                })
            }),
            /*#__PURE__*/ _jsx(Title, {
                size: "lg",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "vGHy7d",
                    defaultMessage: "Edit Default Command"
                })
            }),
            /*#__PURE__*/ _jsx(TextInput, {
                name: "name",
                disabled: true,
                value: (_formik_values_name = formik.values.name) !== null && _formik_values_name !== void 0 ? _formik_values_name : '',
                label: intl.formatMessage({
                    id: "HAlOn1",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Name"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(NativeSelect, {
                name: "userLevel",
                label: intl.formatMessage({
                    id: "yoVadE",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Required User-Level"
                        }
                    ]
                }),
                onBlur: formik.handleBlur,
                value: formik.values.userLevel,
                error: formik.touched.userLevel != null ? formik.errors.userLevel : undefined,
                onChange: formik.handleChange,
                children: Object.entries((_channel_userLevels = channel === null || channel === void 0 ? void 0 : channel.userLevels) !== null && _channel_userLevels !== void 0 ? _channel_userLevels : {}).map(function(param) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                    return /*#__PURE__*/ _jsx("option", {
                        value: key,
                        children: value
                    }, key);
                })
            }),
            /*#__PURE__*/ _jsx(NumberInput, {
                min: MIN_COOLDOWN,
                max: MAX_COOLDOWN,
                label: intl.formatMessage({
                    id: "1PlglC",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Cooldown (seconds)"
                        }
                    ]
                }),
                name: "coolDown",
                error: formik.touched.coolDown != null ? formik.errors.coolDown : undefined,
                onBlur: formik.handleBlur,
                value: (_formik_values_coolDown = formik.values.coolDown) !== null && _formik_values_coolDown !== void 0 ? _formik_values_coolDown : '',
                onChange: function(value) {
                    return formik.setFieldValue('coolDown', value);
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.buttonGroup,
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        size: "xs",
                        onClick: back,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "47FYwb",
                            defaultMessage: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        size: "xs",
                        variant: "inverse",
                        disabled: !formik.dirty || !formik.isValid,
                        onClick: function() {
                            return formik.handleSubmit();
                        },
                        loading: formik.isSubmitting,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "BWpuKl",
                            defaultMessage: "Update"
                        })
                    })
                ]
            }),
            error != null ? /*#__PURE__*/ _jsx(Text, {
                size: "sm",
                className: styles.textError,
                children: error
            }) : null
        ]
    });
}
